import { Network, Briefcase, Layers, Globe2, type LucideIcon } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { getHomeV2 } from "@/content/home-v2";

const ICONS: LucideIcon[] = [Network, Briefcase, Layers, Globe2];

/** "Why IBYLIT?" — four differentiators, placed before case studies. */
const HomeWhyIbylit = (): JSX.Element => {
  const { language } = useLanguage();
  const c = getHomeV2(language).why;

  return (
    <section className="section-band-base py-20 md:py-28">
      <div className="enterprise-container">
        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.25em] text-primary">[ {c.eyebrow} ]</p>
        <h2 className="max-w-3xl font-display text-3xl font-semibold tracking-tight text-foreground md:text-5xl">{c.title}</h2>
        <p className="mt-5 max-w-3xl text-base leading-relaxed text-muted-foreground md:text-lg">{c.lead}</p>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {c.items.map((item, index) => {
            const Icon = ICONS[index] ?? Network;
            return (
              <article key={item.title} className="rounded-2xl border border-border bg-card/60 p-6 transition-colors hover:border-primary/40">
                <span className="inline-flex size-11 items-center justify-center rounded-xl border border-primary/30 bg-primary/10 text-primary">
                  <Icon className="size-5" aria-hidden="true" />
                </span>
                <h3 className="mt-5 font-display text-lg font-semibold text-foreground">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{item.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeWhyIbylit;
